import { render, staticRenderFns } from "./CreateEatingStudy.vue?vue&type=template&id=121b5cb3&scoped=true&"
import script from "./CreateEatingStudy.vue?vue&type=script&lang=js&"
export * from "./CreateEatingStudy.vue?vue&type=script&lang=js&"
import style0 from "./CreateEatingStudy.vue?vue&type=style&index=0&id=121b5cb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b5cb3",
  null
  
)

export default component.exports